export default __webpack_public_path__ + "static/media/Path 132.83bb2da9.svg";